

  <div class="container">
    <div class="flex-header d-flex justify-content-between align-items-center">

      <div dir="rtl" class="btn-menu mobile-header__menu-button">
        <div class="line line-1"></div>
        <div class="line line-2"></div>
        <div class="line line-3"></div>
        <div class="line line-4"></div>
      </div>
      <div class="content-menu d-lg-flex">
        <div class="nav-wrap">
          <nav id="mainnav" class="mainnav">
            <ul class="menu ace-responsive-menu" data-menu-style="horizontal">
              <li><a href="#content" class="click-model">Home</a></li>
              <li><a href="#about" class="click-model">About</a></li>

              <li><a href="#portfolio" class="click-model">Portfolio</a></li>
              <!-- <li><a href="#contact" class="click-model">Contact me</a></li> -->
              <li><a href="#resume" class="click-model">Resume</a></li>
            </ul>
          </nav>
        </div>
      </div>
    </div>
  </div>

